import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { RequireAuth } from '@/lib/auth/RequireAuth';

const SignInPage = lazy(() => import('@/routes/(auth)/sign-in'));
const ForgotPasswordPage = lazy(() => import('@/routes/(auth)/forgot-password'));
const NewCustomerSignUpPage = lazy(() => import('@/routes/(auth)/new-customer-sign-up'));
const UserSignUpPage = lazy(() => import('@/routes/(auth)/user-sign-up'));
const AppShell = lazy(() => import('@/components/layout/AppShell'));

function PageLoader() {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* Public routes */}
        <Route path="/sign-in" element={<SignInPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/new-customer-sign-up" element={<NewCustomerSignUpPage />} />
        <Route path="/user-sign-up" element={<UserSignUpPage />} />

        {/* Protected routes */}
        <Route
          path="/*"
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/sign-in" replace />} />
      </Routes>
    </Suspense>
  );
}
